import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { FullSpinner } from '../index';
import { useFieldsContext } from './context/FieldsContext';
import { InputContainer, GroupStyled, LabelStyled, } from './styles';
import { SubText } from './utils';
const InputStyled = styled.input `
  padding: 0;
  flex: 1 1 0%;
  border: none;
  position: relative;
  outline: none;
`;
const LeadingAddonStyled = styled.div `
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  border-right-width: 0px;
  border-width: 1px;
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
  align-items: center;
  display: inline-flex;

  border-right: none;

  border-color: var(--custom-border-color);
`;
const TrailingAddonStyled = styled.div `
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  border-left-width: 0px;
  border-width: 1px;
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
  align-items: center;
  display: inline-flex;

  border-left: none;

  border-color: var(--custom-border-color);
`;
const LeadingInlineAddonStyled = styled.div `
  display: flex;
  align-items: center;
  padding-right: 0.5rem;
`;
const TrailingInlineAddonStyled = styled.div `
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
`;
export function Input(props) {
    const { variant: variantProps, trailingAddon, leadingAddon, help, error, valid, loading, ...otherProps } = props;
    const { name, variant: contextVariant } = useFieldsContext();
    const hasLeading = (leadingAddon && !leadingAddon.inline) || false;
    const hasTrailing = (trailingAddon && !trailingAddon.inline) || false;
    const variant = variantProps || contextVariant;
    return (_jsxs(InputContainer, { children: [_jsxs(GroupStyled, { hasError: !!error, hasValid: !!valid, children: [leadingAddon && !leadingAddon.inline && (_jsx(LeadingAddonStyled, { children: leadingAddon.addon })), _jsxs(LabelStyled, { variant: variant, hasLeading: hasLeading, hasTrailing: hasTrailing, children: [leadingAddon?.inline && (_jsx(LeadingInlineAddonStyled, { className: "addon", children: leadingAddon.addon })), _jsx(InputStyled, { id: name, name: name, ...otherProps }), trailingAddon?.inline && (_jsx(TrailingInlineAddonStyled, { className: "addon", children: trailingAddon.addon })), loading && (_jsx(TrailingInlineAddonStyled, { style: { height: variant === 'default' ? 20 : 10 }, children: _jsx(FullSpinner, { height: variant === 'default' ? 20 : 10, width: variant === 'default' ? 20 : 10 }) }))] }), trailingAddon && !trailingAddon.inline && (_jsx(TrailingAddonStyled, { children: trailingAddon.addon }))] }), _jsx(SubText, { error: error, help: help, valid: valid })] }));
}
//# sourceMappingURL=Input.js.map